module.exports = new __parcel__URL__("insight-object-view-skeleton.tpl.ec17eb0a.svg").toString();